export const authSlice = (set) => ({
	loginData: null,
	setLoginData: (loginData) => set({ loginData }),
	removeLoginData: () => set(() => ({ loginData: null })),
});
